import { TICKET_STATUS_FILTER } from '../constants/ticketStatuses';
import { DEFAULT_IDENTIFIER_TYPE } from '../constants/identifierTypes';
import {
  SET_ALL_FILTERS,
  UPDATE_FILTER,
  CLEAR_ALL_FILTERS,
  SET_PAGINATION_FOR_ALL_FILTER,
  RESET_PAGINATION_FOR_ALL_FILTER,
  SET_SKIP_FOR_ALL_FILTER,
} from '../actions/types';

export const initialState = {
  ticketStatus: TICKET_STATUS_FILTER.all,
  sortOrder: null,
  identifier: { type: DEFAULT_IDENTIFIER_TYPE, value: '' },
  partialMatch: false,
  dateRange: { startDate: null, endDate: null, startTime: null, endTime: null },
  businessIds: [],
  excludeBusinesses: false,
  selectedBrandOptions: [],
  skip: 0,
  pagination: { hasNextPage: false, hasPreviousPage: false, nextPageCursor: null, previousPageCursor: null },
  hasSearched: false,
};

const allFilters = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_FILTERS:
      return {
        ...state,
        ...action.payload,
        // NOTE(vlad|SPD-14347|2026-03-03): Always reset pagination when bulk-setting filters from URL
        skip: action.payload.skip != null ? action.payload.skip : 0,
        pagination: action.payload.pagination || initialState.pagination,
      };

    case UPDATE_FILTER:
      return {
        ...state,
        [action.field]: action.value,
      };

    case CLEAR_ALL_FILTERS:
      return {
        ...initialState,
      };

    case SET_PAGINATION_FOR_ALL_FILTER:
      return {
        ...state,
        pagination: {
          hasNextPage: action.value.hasNextPage,
          hasPreviousPage: action.value.hasPreviousPage,
          nextPageCursor: action.value.nextPageCursor,
          previousPageCursor: action.value.previousPageCursor,
        },
      };

    case RESET_PAGINATION_FOR_ALL_FILTER:
      return {
        ...state,
        pagination: initialState.pagination,
      };

    case SET_SKIP_FOR_ALL_FILTER:
      return {
        ...state,
        skip: action.value,
      };

    default:
      return state;
  }
};

export default allFilters;
